import * as React from 'react';

import t from './locales';
import { IYadoOrderItem, IYadoRoom, ICurrency } from './types';

import InventoryListView from './InventoryListView';
import InventoryCartItemView from './InventoryCartItemView';
import Price from '../Shared/Price';

interface InventoryYadoOrderItemListProps {
  items: Array<IYadoOrderItem>;
  currentExchangeRate?: number;
  localCurrency?: ICurrency;
}

const InventoryYadoOrderItemList: React.FC<InventoryYadoOrderItemListProps> = (props) => {
  const { items, currentExchangeRate, localCurrency } = props;

  function renderRooms(rooms: IYadoRoom[], index: number) {
    return rooms.map((room: IYadoRoom, roomIndex: number) => (
      <p className="mute" key={`inventory-yado-order-item-${index}-room-${roomIndex}`}>
        {rooms.length > 1 && <strong>部屋{index + 1}</strong>}
        <span>{t.adultNum()} {room.males + room.females}</span>
        <span>{t.childNum()} {room.childAges.length}</span>
      </p>
    ));
  }

  return (
    <React.Fragment>
      {items && items.map((item, index) => {
        const { totalAmountIncludingTax, rooms, resort } = item;
        return (
          <InventoryCartItemView key={`inventory-yado-order-item-${index}`}>
            <div>
              <p>{item.yadoName} / {t.whichRoomType({ roomType: item.roomType })}</p>
              <p className="mute">{resort.resortName}</p>
              {renderRooms(rooms, index)}
            </div>
            <Price
              price={totalAmountIncludingTax}
              fontSize={12}
              localCurrency={localCurrency}/>
          </InventoryCartItemView>
        )
      })}
    </React.Fragment>
  );
}

export default InventoryYadoOrderItemList;
